// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgSoundModuleLine = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 12v2h-1.333v-2h-1.334v-1.333h4V12zM3.333 12v2H2v-2H.667v-1.333h4V12zm4-8V2h1.334v2H10v1.333H6V4zm0 2.667h1.334V14H7.333zM2 9.333V2h1.333v7.333zm10.667 0V2H14v7.333z"
    />
  </svg>
);
export const SoundModuleLineIcon = forwardRef(SvgSoundModuleLine);
